import { Button, Row, Col, Select, Spin , Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { resetForm, setFormValue } from "../features/formSlice";
import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FormNavigator } from "./formNavigator";
import { SettingOutlined } from "@ant-design/icons";
import apiAction from "../ajax/service";
import { debounce } from "../helpers/helper";
import SearchSelect from "../components/atoms/SearchSelectWithDropdown";

const TenantSelect = (customProps) => {
  const dispatch = useDispatch();
  const formNavigator = FormNavigator(dispatch);
  const navigate = useNavigate();

  return (
    <Row>
      <Col span={21}>
        <Select
          optionLabelProp="label"
          optionFilterProp="label"
          options={customProps.options}
          showSearch
          {...customProps}
        />
      </Col>
      <Col span={3}>
        <Button onClick={() => navigate("/tenants")}>
          <SettingOutlined />
          Manage Tenants
        </Button>
      </Col>
    </Row>
  );
};

const RentalSearchSelect = (customProps) =>{
  const dispatch = useDispatch()
  const rentalCounts = useSelector(state => state.form.values.rentalCounts || {})

  const handleQtyChange = (id, value) => {
    dispatch(setFormValue({
      key:'rentalCounts',
      value:{ ...rentalCounts, [id]: value }
    }))
  }

  return (
    <SearchSelect
      showSelected
      field="rental.name"
      onSelect={id => {
        if (!(id in rentalCounts)) {
          dispatch(setFormValue({
            key:'rentalCounts',
            value:{ ...rentalCounts, [id]: 1 }
          }))
        }
      }}

      selectedExtra={id => (
        <div className="flex items-center gap-1 whitespace-nowrap">
          <span >{"| QTY:"}</span>
          <Input
            size="small"
            type="number"
            className="w-[90px] h-6 px-1 text-xs"
            value={rentalCounts[id] || 1}
            onChange={e => handleQtyChange(id, parseInt(e.target.value))}
          />
        </div>
      )}
      {...customProps}
    />
  )
}


// ✅ Register for DynamicForm usage
const customTags = {
  TenantSelect: (customProps) => (
    <TenantSelect key="tenantselect" {...customProps} />
  ),
  RentalMultiSelect: (customProps) => (
    <RentalSearchSelect {...customProps} />
  ),
};

export { customTags };
